import { useEffect } from "react";
import debounce from "lodash.debounce";

const THRESHOLD = 300;

const useInfiniteScroll = (callback, stopFetchingPost, scrollContainerRef = null) => {
  useEffect(() => {
    const el = scrollContainerRef?.current;
    const isContainerScroll = Boolean(el);

    const handleScroll = debounce(() => {
      let scrollTop, clientHeight, scrollHeight;
      if (isContainerScroll && el) {
        scrollTop = el.scrollTop;
        clientHeight = el.clientHeight;
        scrollHeight = el.scrollHeight;
      } else {
        scrollTop = window.scrollY;
        clientHeight = window.innerHeight;
        scrollHeight = document.body.scrollHeight;
      }
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - THRESHOLD;

      if (!stopFetchingPost && isNearBottom) {
        callback();
      }
    }, 200);

    if (isContainerScroll && el) {
      el.addEventListener("scroll", handleScroll);
      handleScroll(); // initial check in case content is short and already at bottom
      return () => {
        el.removeEventListener("scroll", handleScroll);
        handleScroll.cancel();
      };
    }

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      handleScroll.cancel();
    };
  }, [callback, stopFetchingPost, scrollContainerRef]);
};

export default useInfiniteScroll;
